import type { RouteRecordRaw } from 'vue-router'

/**
 * Administrácia partnerov.
 *
 * Zoznam a zakladanie sú pre importéra. Kartu partnera otvára aj partner sám —
 * cez `/moja-firma`, bez identifikátora v adrese; ktorého partnera uvidí,
 * rozhoduje token, nie URL.
 */
export const adminRoutes: RouteRecordRaw[] = [
	{
		path: '/admin/partneri',
		name: 'admin-partners',
		component: () => import('./AdminPartnersPage.vue'),
		meta: {
			titleSk: 'Partneri',
			breadcrumbSk: ['Administrácia'],
			requiresAuth: true,
			roles: ['TENANT_ADMIN', 'TENANT_SALES', 'SUPERADMIN'],
		},
	},
	{
		path: '/admin/partneri/:id',
		name: 'admin-partner-detail',
		component: () => import('./PartnerDetailPage.vue'),
		meta: {
			titleSk: 'Karta partnera',
			breadcrumbSk: ['Administrácia', 'Partneri'],
			requiresAuth: true,
			roles: ['TENANT_ADMIN', 'TENANT_SALES', 'SUPERADMIN'],
		},
	},
	{
		path: '/moja-firma',
		name: 'my-company',
		component: () => import('./PartnerDetailPage.vue'),
		meta: { titleSk: 'Moja firma', requiresAuth: true },
	},
	{
		path: '/admin/cenniky',
		name: 'admin-price-lists',
		component: () => import('./AdminPriceListsPage.vue'),
		meta: {
			titleSk: 'Cenníky',
			breadcrumbSk: ['Administrácia'],
			requiresAuth: true,
			roles: ['TENANT_ADMIN', 'SUPERADMIN'],
		},
	},
]
